export default {
    getGroupSubscribers: { method: 'get', url: 'signatures/group-subscribers' },
    postGroupSubscribers: { method: 'post', url: 'signatures/group-subscribers' },
    putGroupSubscribers: { method: 'put', url: 'signatures/group-subscribers/{id}' },
    deleteGroupSubscribers: { method: 'delete', url: 'signatures/group-subscribers/{id}' },
}
